import { z } from 'zod'

import type { NoContext } from '~/services/api/contracts/NoContext'
import { fieldNormalizer } from '~/services/api/contracts/fieldNormalizer'
import { LegalAgreementEmailRequestSchema } from '~/services/api/generated'
import { distinctEmailEntries } from '~/utils/distinctEmailEntries'

const normalize = fieldNormalizer({
  custom: [
    {
      keys: ['emails'],
      apply: (value) =>
        Array.isArray(value)
          ? distinctEmailEntries(
              value.filter((entry): entry is string => typeof entry === 'string')
            )
          : value
    }
  ]
})

export const LegalAgreementEmail = (_context: NoContext = {}) =>
  z.preprocess(normalize, LegalAgreementEmailRequestSchema.strict())
